import { BROADCAST_SET_PROGRAM } from 'actions/Types';
import agoraOnstageAttendeeUpdater from '@cvent/studio-agora/metrics/agoraOnstageAttendeeUpdater';
import handleAgoraOnStagePriority from '@shoflo/studio-redux/actions/meeting/handleAgoraOnStagePriority';
import { shouldHaveFeature } from '@studio/feature.flags';
import { VENDOR_AGORA } from '@studio/constants';

function setProgram(scene) {
  return (dispatch, getState) => {
    const action = {
      type: BROADCAST_SET_PROGRAM,
      payload: scene
    };
    if (shouldHaveFeature('studio.meetingVendor') === VENDOR_AGORA) {
      const { meeting } = getState();
      agoraOnstageAttendeeUpdater(scene, meeting);
      dispatch(handleAgoraOnStagePriority({ payload: scene }));
    }
    dispatch(action);
  };
}

export default setProgram;
